import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMOperationType } from './typings';

@Component({
  selector: 'm-operations-zoom',
  template: `
    <div class="m-operations-zoom">
      <i nz-icon (click)="onZoomOut()" [class.disable]="sliderValue === min">
        <ng-container *ngIf="mAreaType === 'headerArea'; else elseTemplate">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-业务组件/工具栏导航" transform="translate(-353.000000, -468.000000)">
                <g id="-mockplus-" transform="translate(44.000000, 456.000000)">
                  <g id="编组-3" transform="translate(309.000000, 10.000000)">
                    <g id="-mockplus-" transform="translate(0.000000, 2.000000)">
                      <g id="编组" transform="translate(1.000000, 1.000000)">
                        <path
                          d="M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M7,1 C3.6862915,1 1,3.6862915 1,7 C1,10.3137085 3.6862915,13 7,13 C10.3137085,13 13,10.3137085 13,7 C13,3.6862915 10.3137085,1 7,1 Z"
                          id="形状结合"
                          fill="#3D4757"
                        ></path>
                        <path
                          d="M10.3541667,6.41666667 L3.64583333,6.41666667 C3.565625,6.41666667 3.5,6.48229167 3.5,6.5625 L3.5,7.4375 C3.5,7.51770833 3.565625,7.58333333 3.64583333,7.58333333 L10.3541667,7.58333333 C10.434375,7.58333333 10.5,7.51770833 10.5,7.4375 L10.5,6.5625 C10.5,6.48229167 10.434375,6.41666667 10.3541667,6.41666667 Z"
                          id="路径"
                          fill="#107CEE"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-container>
        <ng-template #elseTemplate>
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 14 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-02业务组件/底部工具栏设计" transform="translate(-1192.000000, -347.000000)" fill="#595959">
                <g id="-mockplus-" transform="translate(44.000000, 340.000000)">
                  <g id="编组-5" transform="translate(1148.000000, 4.000000)">
                    <g id="-mockplus-" transform="translate(0.000000, 3.000000)">
                      <g id="编组" transform="translate(0.875000, 0.875000)">
                        <path
                          d="M6.125,0 C9.50774409,0 12.25,2.74225591 12.25,6.125 C12.25,9.50774409 9.50774409,12.25 6.125,12.25 C2.74225591,12.25 0,9.50774409 0,6.125 C0,2.74225591 2.74225591,0 6.125,0 Z M6.125,0.875 C3.22550506,0.875 0.875,3.22550506 0.875,6.125 C0.875,9.02449494 3.22550506,11.375 6.125,11.375 C9.02449494,11.375 11.375,9.02449494 11.375,6.125 C11.375,3.22550506 9.02449494,0.875 6.125,0.875 Z"
                          id="形状结合"
                        ></path>
                        <path
                          d="M9.05989583,5.61458333 L3.19010417,5.61458333 C3.11992188,5.61458333 3.0625,5.67200521 3.0625,5.7421875 L3.0625,6.5078125 C3.0625,6.57799479 3.11992188,6.63541667 3.19010417,6.63541667 L9.05989583,6.63541667 C9.13007813,6.63541667 9.1875,6.57799479 9.1875,6.5078125 L9.1875,5.7421875 C9.1875,5.67200521 9.13007813,5.61458333 9.05989583,5.61458333 Z"
                          id="路径"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-template>
      </i>
      <div class="m-operations-zoom-slider" *ngIf="mAreaType === 'footerArea'">
        <nz-slider [nzMin]="min" [nzMax]="max" [(ngModel)]="sliderValue" [nzStep]="10" (ngModelChange)="onZoomChange()"></nz-slider>
      </div>
      <ng-template *ngIf="mAreaType === 'footerArea'" [ngTemplateOutlet]="plusZoomRef"></ng-template>
      <div nz-dropdown [nzDropdownMenu]="zoomPanel" class="m-operations-zoom-drop-btn">
        {{ sliderValue }}%
        <i nz-icon nzType="caret-down" nzTheme="outline"></i>
      </div>
      <ng-template *ngIf="mAreaType === 'headerArea'" [ngTemplateOutlet]="plusZoomRef"></ng-template>
      <nz-dropdown-menu #zoomPanel="nzDropdownMenu">
        <ul nz-menu class="m-operations-zoom-dropdown">
          <li nz-menu-item *ngFor="let radio of mRadios" (click)="onZoomSelect(radio)" [class.disable]="sliderValue === radio">
            <div class="indent">
              <i nz-icon nzType="check" nzTheme="outline" *ngIf="sliderValue === radio"></i>
            </div>
            {{ radio }}%
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>

    <ng-template #plusZoomRef>
      <i nz-icon (click)="onZoomIn()" [class.disable]="sliderValue === max">
        <ng-container *ngIf="mAreaType === 'headerArea'; else elseTemplate">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-业务组件/工具栏导航" transform="translate(-457.000000, -468.000000)">
                <g id="-mockplus-" transform="translate(44.000000, 456.000000)">
                  <g id="编组-3" transform="translate(309.000000, 10.000000)">
                    <g id="Icon/TwoTone/edit/-fullsize" transform="translate(104.000000, 2.000000)">
                      <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                      <g id="编组" transform="translate(1.000000, 1.000000)">
                        <path
                          d="M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M7,1 C3.6862915,1 1,3.6862915 1,7 C1,10.3137085 3.6862915,13 7,13 C10.3137085,13 13,10.3137085 13,7 C13,3.6862915 10.3137085,1 7,1 Z"
                          id="形状结合"
                          fill="#3D4757"
                        ></path>
                        <path
                          d="M10.3541667,6.41666667 L7.58333333,6.41666667 L7.58333333,3.64583333 C7.58333333,3.565625 7.51770833,3.5 7.4375,3.5 L6.5625,3.5 C6.48229167,3.5 6.41666667,3.565625 6.41666667,3.64583333 L6.41666667,6.41666667 L3.64583333,6.41666667 C3.565625,6.41666667 3.5,6.48229167 3.5,6.5625 L3.5,7.4375 C3.5,7.51770833 3.565625,7.58333333 3.64583333,7.58333333 L6.41666667,7.58333333 L6.41666667,10.3541667 C6.41666667,10.434375 6.48229167,10.5 6.5625,10.5 L7.4375,10.5 C7.51770833,10.5 7.58333333,10.434375 7.58333333,10.3541667 L7.58333333,7.58333333 L10.3541667,7.58333333 C10.434375,7.58333333 10.5,7.51770833 10.5,7.4375 L10.5,6.5625 C10.5,6.48229167 10.434375,6.41666667 10.3541667,6.41666667 Z"
                          id="路径"
                          fill="#107CEE"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-container>
        <ng-template #elseTemplate>
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 14 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-02业务组件/底部工具栏设计" transform="translate(-1296.000000, -347.000000)">
                <g id="-mockplus-" transform="translate(44.000000, 340.000000)">
                  <g id="编组-5" transform="translate(1148.000000, 4.000000)">
                    <g id="编组-2" transform="translate(19.000000, 0.000000)">
                      <g id="Icon/TwoTone/edit/-fullsize" transform="translate(85.000000, 3.000000)">
                        <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="14" height="14"></rect>
                        <g id="编组" transform="translate(0.875000, 0.875000)">
                          <path
                            d="M6.125,0 C9.50774409,0 12.25,2.74225591 12.25,6.125 C12.25,9.50774409 9.50774409,12.25 6.125,12.25 C2.74225591,12.25 0,9.50774409 0,6.125 C0,2.74225591 2.74225591,0 6.125,0 Z M6.125,0.875 C3.22550506,0.875 0.875,3.22550506 0.875,6.125 C0.875,9.02449494 3.22550506,11.375 6.125,11.375 C9.02449494,11.375 11.375,9.02449494 11.375,6.125 C11.375,3.22550506 9.02449494,0.875 6.125,0.875 Z"
                            id="形状结合"
                            fill="#3D4757"
                          ></path>
                          <path
                            d="M9.05989583,5.61458333 L6.63541667,5.61458333 L6.63541667,3.19010417 C6.63541667,3.11992188 6.57799479,3.0625 6.5078125,3.0625 L5.7421875,3.0625 C5.67200521,3.0625 5.61458333,3.11992188 5.61458333,3.19010417 L5.61458333,5.61458333 L3.19010417,5.61458333 C3.11992188,5.61458333 3.0625,5.67200521 3.0625,5.7421875 L3.0625,6.5078125 C3.0625,6.57799479 3.11992188,6.63541667 3.19010417,6.63541667 L5.61458333,6.63541667 L5.61458333,9.05989583 C5.61458333,9.13007813 5.67200521,9.1875 5.7421875,9.1875 L6.5078125,9.1875 C6.57799479,9.1875 6.63541667,9.13007813 6.63541667,9.05989583 L6.63541667,6.63541667 L9.05989583,6.63541667 C9.13007813,6.63541667 9.1875,6.57799479 9.1875,6.5078125 L9.1875,5.7421875 C9.1875,5.67200521 9.13007813,5.61458333 9.05989583,5.61458333 Z"
                            id="路径"
                            fill="#595959"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-template>
      </i>
    </ng-template>
  `,
  host: {
    class: 'm-operations-label-zoom'
  }
})
export class MOperationsZoomComponent {
  @Input() mZoom = 1;
  @Input() mRadios = [40, 60, 80, 100, 120, 140, 160, 180, 200, 250, 300, 350, 400];
  @Input() mAreaType: IMOperationType = 'headerArea';
  @Output() readonly mZoomChange = new EventEmitter<number>();

  sliderValue = 100;
  min = this.mRadios[0];
  max = this.mRadios[this.mRadios.length - 1];
  step = 20;

  onZoomIn(): void {
    this.sliderValue += this.step;
    if (this.sliderValue > this.max) {
      this.sliderValue = this.max;
    }
    this.onZoomChange();
  }

  onZoomOut(): void {
    this.sliderValue -= this.step;
    if (this.sliderValue < this.min) {
      this.sliderValue = this.min;
    }
    this.onZoomChange();
  }

  onZoomSelect(zoom: number): void {
    this.sliderValue = zoom;
    this.onZoomChange();
  }

  onZoomChange(): void {
    this.mZoomChange.emit(this.sliderValue / 100);
  }
}
